export default __webpack_public_path__ + "static/media/regulatory--low-beam-headlights--g3.27cdd23a.png";